import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';
import { Colors, Sizes } from '../../../shared/enums/shared.enums';
import { CaasComponent } from '../../../shared/interfaces/caas/caas.interface';
import { safeAssign } from '../../../shared/utils/safe-assign.util';
import { ErrorHandlerService } from '../../../services/error-handler.service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'hdi-quote',
  standalone: true,
  imports: [CommonModule, IconComponent, NgxSkeletonLoaderModule],
  templateUrl: './quote.component.html',
  styleUrl: './quote.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class QuoteComponent implements OnChanges {
  @Input() quote: string = '';
  @Input() quote_headline: string = '';
  @Input() quote_name: string = '';
  @Input() quote_subline: string = '';
  @Input() caasData?: CaasComponent;
  color = Colors;
  size = Sizes;
  constructor(private readonly errorHandler: ErrorHandlerService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['caasData'] && this.caasData) {
      this.setCaasContent(this.caasData);
    }
  }

  setCaasContent(caasData: CaasComponent): void {
    safeAssign(
      () => {
        if (
          caasData?.formData?.st_items?.value &&
          Array.isArray(caasData.formData.st_items.value)
        ) {
          const firstQuote = caasData.formData.st_items.value[0];

          if (firstQuote?.formData) {
            safeAssign(
              () => {
                this.quote = firstQuote.formData.st_text?.value || '';
              },
              'Assigning quote content',
              this.errorHandler
            );

            safeAssign(
              () => {
                this.quote_name = firstQuote.formData.st_person?.value || '';
              },
              'Assigning quote author and subline',
              this.errorHandler
            );
            safeAssign(
              () => {
                this.quote_subline =
                  firstQuote.formData.st_subline?.value || '';
              },
              'Assigning quote subline',
              this.errorHandler
            );
          }
        }
      },
      'Assigning quote content',
      this.errorHandler
    );
  }
}
